import CareersListing from "../careers/views/pages/careersListing.vue";
import CareersDetails from "../careers/views/pages/careersDetails.vue";
import CareerColumnsName from "../careers/views/pages/careerColumns.vue";
export const careersRouters = [
  {
    path: "/careers",
    name: "CareersListing",
    component: CareersListing,
  },
  {
    path: "/settings/career-columns-names",
    name: "CareerColumnName",
    component: CareerColumnsName,
  },
  {
    path: "/career-datails/:id",
    name: "CareersDetails",
    component: CareersDetails,
  },
];
